// Reverse-map single-letter tactic codes sent by the engine back to the numeric IDs used in the UI.
export const tacticIdReverseMapping = { A: 1, N: 2, D: 3, C: 4, P: 5, L: 6 };

const validUiTacticIds = new Set(Object.values(tacticIdReverseMapping));
const tacticIdToEngineCodeMapping = Object.fromEntries(
    Object.entries(tacticIdReverseMapping).map(([engineCode, uiTacticId]) => [uiTacticId, engineCode])
);

export const normaliseTacticIdForUi = (value) => {
    if (value === null || value === undefined) return undefined;

    const normalised = typeof value === 'string' ? value.trim() : value;
    if (normalised === '') return undefined;
    if (typeof normalised !== 'string' && typeof normalised !== 'number') return undefined;

    const engineLetter = typeof normalised === 'string' ? normalised.toUpperCase() : normalised;
    if (tacticIdReverseMapping[engineLetter]) {
        return tacticIdReverseMapping[engineLetter];
    }

    const numericValue = Number(normalised);
    return Number.isInteger(numericValue) && validUiTacticIds.has(numericValue) ? numericValue : undefined;
};

export const patchSavedTacticIntoMatchData = ({ matchData, userTeamSide, tacticId, formation }) => {
    if (!matchData || !userTeamSide) return matchData;

    const teamKey = `${userTeamSide}Team`;
    const matchTeam = matchData[teamKey];
    if (!matchTeam) return matchData;

    const normalisedTacticId = normaliseTacticIdForUi(tacticId);
    if (!normalisedTacticId) return matchData;

    const engineTacticId = tacticIdToEngineCodeMapping[normalisedTacticId] || tacticId;
    const normalisedFormation = typeof formation === 'string' ? formation.trim() : formation;
    const hasFormation = normalisedFormation !== null && normalisedFormation !== undefined && normalisedFormation !== '';

    return {
        ...matchData,
        [teamKey]: {
            ...matchTeam,
            tacticId: normalisedTacticId,
            teamsheet: {
                ...(matchTeam.teamsheet || {}),
                tacticId: engineTacticId,
                ...(hasFormation ? { formation: normalisedFormation } : {})
            }
        }
    };
};
